<template>
  <validation-observer ref="form" novalidate>
    <section-title
      content="Comentarios de Bitácora"
      class="subsection-title"
      icon="fas fa-comment"
      reverse
    />
    <add v-if="!isReadOnly" v-model="binnacle" @save="add" @cancel="cancel" />
    <custom-separator text="Comentarios" class="my-4 custom-separator-line" />
    <div v-if="hasResults" class="search-result">
      <result-row
        class="mt-3"
        v-for="item in pagination.data"
        :key="item.id"
        :item="item"
        :is-read-only="isReadOnly"
        @quit="quit"
      />
      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="get"
      />
    </div>

    <custom-result-not-found
      v-else
      class="mt-4 row pt-3"
      text="No hay información disponible."
    />
  </validation-observer>
</template>

<script>
//mixins
import alertMixin from '@/mixin/alert.mixin.js';

//components
import SectionTitle from 'SectionTitle';
import CustomTextArea from 'CustomTextArea';
import CustomInput from 'CustomInput';
import CustomResultNotFound from 'custom-result-not-found';
import CustomSeparator from 'custom-separator';
import Pagination from 'pagination';

import Add from './components/Add.vue';
import ResultRow from './components/ResultRow.vue';

//services
import {
  getBinnacles,
  addBinnacle,
  removeBinnacle,
} from '@/services/vocational-rehabilitation-referral/api.js';

const DEFAULT_PAGE_SIZE = 20;

export default {
  name: 'BinnacleTab',
  mixins: [alertMixin],
  components: {
    SectionTitle,
    CustomTextArea,
    CustomInput,
    CustomResultNotFound,
    CustomSeparator,
    Add,
    ResultRow,
    Pagination,
  },
  props: {
    id: {
      type: [Number, String],
      default: () => null,
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    status: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    hasResults() {
      return Boolean(this.pagination.data?.length);
    },
  },
  data() {
    return {
      binnacle: {
        subject: null,
        comment: null,
      },
      pagination: {
        count: 0,
        currentPage: 1,
        pageCount: 1,
        totalItemCount: 0,
        pageSize: DEFAULT_PAGE_SIZE,
        data: [],
      },
    };
  },
  async mounted() {
    this.$emit('update:disabled', true);
    await this.get();
    this.$emit('update:disabled', false);
  },
  methods: {
    async get(page = 1) {
      const { pageSize: size } = this.pagination;

      const { data: res } = await getBinnacles(this.id, { page, size });
      this.pagination = {
        ...res,
        pageSize: DEFAULT_PAGE_SIZE,
      };
    },
    async validate() {
      return Promise.resolve({
        tabId: 'Binnacle',
        title: 'Bitácora',
        valid: true,
        items: [],
      });
    },
    async add(payload, callback) {
      try {
        await addBinnacle(this.id, payload);
        await this.get(this.pagination.currentPage);
        this.cancel(callback);
        this.ShowToast(
          'Éxito',
          'El comentario de bitácora fue guardado exitosamente.',
          'success'
        );
      } catch (e) {
        this.ShowToast(
          'Error',
          'No se pudo guardar el comentario. Intente nuevamente.',
          'error'
        );
      }
    },
    cancel(callback) {
      this.binnacle = {
        subject: null,
        comment: null,
      };
      if (callback) callback();
    },
    async quit(item) {
      const { value: confirmed, dismiss } = await this.ShowCancelModalClosable(
        '¿Eliminar comentario de bitácora?',
        'Este comentario se eliminará y no podrá recuperarse.'
      );
      const cancelled = ['close', 'backdrop'].includes(dismiss);
      if (cancelled || !confirmed) return;
      try {
        await removeBinnacle(this.id, item.id);
        await this.get(this.pagination.currentPage);
        this.ShowToast(
          'Éxito',
          'El comentario de bitácora fue eliminado exitosamente.',
          'success'
        );
      } catch (e) {
        this.ShowToast(
          'Error',
          'No se pudo eliminar el comentario. Intente nuevamente.',
          'error'
        );
      }
    },
  },
};
</script>

<style scoped></style>
